import * as Sentry from '@sentry/react'
import { createEvent } from 'effector'

export type SentryErrorInfo = {
  error: unknown
  context?: { [key: string]: unknown }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function captureError(
  error: SentryErrorInfo['error'],
  context?: SentryErrorInfo['context']
) {
  Sentry.withScope((scope) => {
    if (context) {
      Object.entries(context).forEach(([key, value]) => {
        scope.setExtra(key, value)
      })
    }

    Sentry.captureException(
      error instanceof Error ? error : new Error(String(error))
    )
  })
}

export const doCaptureSentryError = createEvent<SentryErrorInfo>()
doCaptureSentryError.watch((errInfo) => {
  captureError(errInfo.error, errInfo.context)
})
